//  Auth - Signup
export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

//  Auth - Login
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

//  Auth - Logout
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

//  Complete KYC
export const COMPLETE_KYC = "COMPLETE_KYC";
export const COMPLETE_KYC_SUCCESS = "COMPLETE_KYC_SUCCESS";
export const COMPLETE_KYC_FAILURE = "COMPLETE_KYC_FAILURE";

//  Complete KYC
export const ACCEPT_REJECT = "ACCEPT_REJECT";
export const ACCEPT_REJECT_SUCCESS = "ACCEPT_REJECT_SUCCESS";
export const ACCEPT_REJECT_FAILURE = "ACCEPT_REJECT_FAILURE";

//  Dashboard get balance
export const GET_BALANCE = "GET_BALANCE";
export const GET_BALANCE_SUCCESS = "GET_BALANCE_SUCCESS";
export const GET_BALANCE_FAILURE = "GET_BALANCE_FAILURE";

//  Dashboard get userdata
export const GET_USERDATA = "GET_USERDATA";
export const GET_USERDATA_SUCCESS = "GET_USERDATA_SUCCESS";
export const GET_USERDATA_FAILURE = "GET_USERDATA_FAILURE";

// Dashboard deposit to moneyplant
export const DEPOSIT_MONEYPLANT = "DEPOSIT_MONEYPLANT";
export const DEPOSIT_MONEYPLANT_SUCCESS = "DEPOSIT_MONEYPLANT_SUCCESS";
export const DEPOSIT_MONEYPLANT_FAILURE = "DEPOSIT_MONEYPLANT_FAILURE";

export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILURE = "VERIFY_EMAIL_FAILURE";

export const CRYPTO_PAYMENT = "CRYPTO_PAYMENT";
export const CRYPTO_PAYMENT_SUCCESS = "CRYPTO_PAYMENT_SUCCESS";
export const CRYPTO_PAYMENT_FAILURE = "CRYPTO_PAYMENT_FAILURE";

export const ADD_NEW_ADDRESS = "ADD_NEW_ADDRESS";
export const ADD_NEW_ADDRESS_SUCCESS = "ADD_NEW_ADDRESS_SUCCESS";
export const ADD_NEW_ADDRESS_FAILURE = "ADD_NEW_ADDRESS_SUCCESS";

export const GET_ADDRESS_CARD = "GET_ADDRESS_CARD";
export const GET_ADDRESS_CARD_SUCCESS = "GET_ADDRESS_CARD_SUCCESS";
export const GET_ADDRESS_CARD_FAILURE = "GET_ADDRESS_CARD_FAILURE";

// Monumpay
export const MONUMPAY_DEPOSIT = "MONUMPAY_DEPOSIT";
export const MONUMPAY_DEPOSIT_SUCCESS = "MONUMPAY_DEPOSIT_SUCCESS";
export const MONUMPAY_DEPOSIT_FAILURE = "MONUMPAY_DEPOSIT_FAILURE";

export const MONUMPAY_WITHDRAWAL = "MONUMPAY_WITHDRAWAL";
export const MONUMPAY_WITHDRAWAL_SUCCESS = "MONUMPAY_WITHDRAWAL_SUCCESS";
export const MONUMPAY_WITHDRAWAL_FAILURE = "MONUMPAY_WITHDRAWAL_FAILURE";

export const MONUMPAY_WITHDRAWAL_REQUEST = "MONUMPAY_WITHDRAWAL_REQUEST";
export const MONUMPAY_WITHDRAWAL_REQUEST_SUCCESS ="MONUMPAY_WITHDRAWAL_REQUEST_SUCCESS";
export const MONUMPAY_WITHDRAWAL_REQUEST_FAILURE ="MONUMPAY_WITHDRAWAL_REQUEST_FAILURE";

export const BANK_WIRE_TRANSFER = "BANK_WIRE_TRANSFER";
export const BANK_WIRE_TRANSFER_SUCCESS = "BANK_WIRE_TRANSFER_SUCCESS";
export const BANK_WIRE_TRANSFER_FAILURE = "BANK_WIRE_TRANSFER_FAILURE";

export const NGENIUS_DEPOSIT = "NGENIUS_DEPOSIT";
export const NGENIUS_DEPOSIT_SUCCESS = "NGENIUS_DEPOSIT_SUCCESS";
export const NGENIUS_DEPOSIT_FAILURE = "NGENIUS_DEPOSIT_FAILURE";

export const EMAIL_WITHDRAW = "EMAIL_WITHDRAW";
export const EMAIL_WITHDRAW_SUCCESS = "EMAIL_WITHDRAW_SUCCESS";
export const EMAIL_WITHDRAW_FAILURE = "EMAIL_WITHDRAW_FAILURE";

//Top Dashboad Data 

export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_DASHBOARD_DATA_SUCCESS = "GET_DASHBOARD_DATA_SUCCESS";
export const GET_DASHBOARD_DATA_FAILURE = "GET_DASHBOARD_DATA_FAILURE";

//Recent Transactions

export const GET_RECENT_TRANSACTIONS = "GET_RECENT_TRANSACTIONS";
export const GET_RECENT_TRANSACTIONS_SUCCESS = "GET_RECENT_TRANSACTIONS_SUCCESS";
export const GET_RECENT_TRANSACTIONS_FAILURE = "GET_RECENT_TRANSACTIONS_FAILURE";

//get whitelabel
export const GET_WHITELABELS = "GET_WHITELABELS";
export const GET_WHITELABELS_SUCCESS = "GET_WHITELABELS_SUCCESS";
export const GET_WHITELABELS_FAILURE = "GET_WHITELABELS_FAILURE";

//create live account
export const CREATE_LIVE_ACCOUNT = "CREATE_LIVE_ACCOUNT";
export const CREATE_LIVE_ACCOUNT_SUCCESS = "CREATE_LIVE_ACCOUNT_SUCCESS";
export const CREATE_LIVE_ACCOUNT_FAILURE = "CREATE_LIVE_ACCOUNT_FAILURE";

//get partner account details of IB

export const GET_PARTNER_ACCOUNT = "GET_PARTNER_ACCOUNT";
export const GET_PARTNER_ACCOUNT_SUCCESS = "GET_PARTNER_ACCOUNT_SUCCESS";
export const GET_PARTNER_ACCOUNT_FAILURE = "GET_PARTNER_ACCOUNT_FAILURE";


export const CREATE_TRANSACTION_ACCOUNT = "CREATE_TRANSACTION_ACCOUNT";
export const CREATE_TRANSACTION_ACCOUNT_SUCCESS = "CREATE_TRANSACTION_ACCOUNT_SUCCESS";
export const CREATE_TRANSACTION_ACCOUNT_FAILURE = "CREATE_TRANSACTION_ACCOUNT_FAILURE";

export const MT5_DEPOSIT_WIDTHDRAW = "MT5_DEPOSIT_WIDTHDRAW";
export const MT5_DEPOSIT_WIDTHDRAW_SUCCESS = "MT5_DEPOSIT_WIDTHDRAW_SUCCESS";
export const MT5_DEPOSIT_WIDTHDRAW_FAILURE = "MT5_DEPOSIT_WIDTHDRAW_FAILURE";

//get Activities
export const GET_USER_ACTIVITIES = "GET_USER_ACTIVITIES";
export const GET_USER_ACTIVITIES_SUCCESS = "GET_USER_ACTIVITIES_SUCCESS";
export const GET_USER_ACTIVITIES_FAILURE = "GET_USER_ACTIVITIES_FAILURE";

export const SEND_PROFILE_DATA = "SEND_PROFILE_DATA";
export const SEND_PROFILE_DATA_SUCCESS = "SEND_PROFILE_DATA_SUCCESS";
export const SEND_PROFILE_DATA_FAILURE = "SEND_PROFILE_DATA_FAILURE";

// Support Ticket Actions
export const CREATE_SUPPORT_TICKET = "CREATE_SUPPORT_TICKET";
export const CREATE_SUPPORT_TICKET_SUCCESS = "CREATE_SUPPORT_TICKET_SUCCESS";
export const CREATE_SUPPORT_TICKET_FAILURE = "CREATE_SUPPORT_TICKET_FAILURE";

export const GET_SUPPORT_TICKETS = "GET_SUPPORT_TICKETS";
export const GET_SUPPORT_TICKETS_SUCCESS = "GET_SUPPORT_TICKETS_SUCCESS";
export const GET_SUPPORT_TICKETS_FAILURE = "GET_SUPPORT_TICKETS_FAILURE";

export const STRIPE_PAYMENT = "STRIPE_PAYMENT";
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS";
export const STRIPE_PAYMENT_FAILURE = "STRIPE_PAYMENT_FAILURE";

// Trade Order
export const GET_TRADE_ORDERS = "GET_TRADE_ORDERS";
export const GET_TRADE_ORDERS_SUCCESS = "GET_TRADE_ORDERS_SUCCESS";
export const GET_TRADE_ORDERS_FAILURE = "GET_TRADE_ORDERS_FAILURE";

// Corporate Signup
export const SUBMIT_CORPORATE_STEP = "SUBMIT_CORPORATE_STEP";
export const SUBMIT_CORPORATE_STEP_SUCCESS = "SUBMIT_CORPORATE_STEP_SUCCESS";
export const SUBMIT_CORPORATE_STEP_FAILURE = "SUBMIT_CORPORATE_STEP_FAILURE";
